import RequestNewPasswordForm from './RequestNewPasswordForm'

export default RequestNewPasswordForm
